
import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { sanitizeInternalPath } from "@/utils/url";
import { SignInCard } from "@/components/ui/sign-in-card";
import { useAuth } from "@/contexts/AuthContext";

const FancySignIn = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [params] = useSearchParams();
  
  // If user is already authenticated, redirect to dashboard
  // Wait for loading to complete to avoid race conditions
  useEffect(() => {
    if (!loading && user) {
      const safe = sanitizeInternalPath(params.get('next'));
      if (safe) {
        navigate(safe);
      } else {
        navigate("/dashboard");
      }
    }
  }, [user, loading, navigate, params]);
  
  // Show loading spinner while authentication state is being determined
  if (loading) {
    return (
      <div className="h-screen w-screen flex items-center justify-center bg-black">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#5956F6]"></div>
      </div>
    );
  }
  
  // Use h-screen for viewport fill, overflow-y-auto allows scroll if content exceeds viewport
  return (
    <div className="h-screen w-screen overflow-x-hidden overflow-y-auto">
      <SignInCard />
    </div>
  );
};

export default FancySignIn;